export default {
	methods: {
		setResolution (isPresentation) {

			let tempWidth
			let tempHeight

			if (this.tempResolution.resolution) {

				if (this.tempResolution.resolution === 'custom') {
					tempWidth = parseInt(this.tempResolution.resolutionWidth)
					tempHeight = parseInt(this.tempResolution.resolutionHeight)
					this.form.settings.orientation = tempWidth >= tempHeight ? 'landscape' : 'portrait'
				}

				if (this.tempResolution.resolution === 'landscape') {
					tempWidth = 1920
					tempHeight = 1080
				}

				if (this.tempResolution.resolution === 'portrait') {
					tempWidth = 1080
					tempHeight = 1920
				}

				this.form.settings.resolution = `${tempWidth}x${tempHeight}`
				this.form.settings.orientation = tempWidth >= tempHeight ? 'landscape' : 'portrait'

				if (isPresentation) {
					this.form.settings.columns = tempWidth >= tempHeight ? this.$config.defaultGridSize : 2 * Math.round(Math.round(tempWidth / (tempHeight / this.$config.defaultGridSize)) / 2)
					this.form.settings.rows = tempWidth >= tempHeight ? 2 * Math.round(Math.round(tempHeight / (tempWidth / this.$config.defaultGridSize)) / 2) : this.$config.defaultGridSize
				}

			}

		}
	}
}
